import { call, put, takeEvery } from "redux-saga/effects";
import { storeSuccess, storeFailed, getHistorySuccess } from ".";
import { message } from "antd";
import { serverIp } from "../../../utils";

export function* storeHistory({ payload }: any): any {
  const { email, news } = payload;
  const requestUrl = `${serverIp}/store_history`;
  const historyPayload = {
    email: email,
    news: news,
  };
  try {
    // Send JSON data in the request body
    const data = yield call(() =>
      fetch(requestUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(historyPayload),
      })
    );

    const parsedData = yield data.json();
    message.success("News Stored Successfully");
    yield put(storeSuccess(parsedData));
  } catch (err) {
    message.error("News Store Failed");
    yield put(storeFailed());
  }
}

export function* getHistory({ payload }: any): any {
  const { token } = payload;
  const requestUrl = `${serverIp}/get_history`;
  try {
    // Send JSON data in the request body
    const data = yield call(() =>
      fetch(requestUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
    );

    const parsedData = yield data.json();
    yield put(getHistorySuccess(parsedData));
  } catch (err) {
    yield put(storeFailed());
  }
}

function* historySaga() {
  yield takeEvery("historyApi/storeNews", storeHistory);
  yield takeEvery("historyApi/getHistory", getHistory);
}

export default historySaga;
